import { ExceptionDimensions, ResponseCode, logAnalyticsEvent } from '@vestico/utils';

import { ConversionEventBody, ConversionResponse, UserModel } from '@vestico/model';

import { AuthorizedRequestInfo, ConversionApi, ProductConfiguration } from '../model/api';
import { AbstractApiClient } from './apiClient';
import { createAPIRequestURL, fetchRequest } from './helpers';

export class ConversionApiClient extends AbstractApiClient implements ConversionApi {
  public async recordConversion(
    orderUID: string,
    items: ProductConfiguration[],
    user: UserModel,
    authRequestInfo: AuthorizedRequestInfo
  ): Promise<ConversionResponse | null> {
    const userUID = user.uid;
    if (!userUID) {
      console.debug('no user recorded');
    }

    if (!orderUID || !items || !authRequestInfo || !this.clientId) {
      console.error('conversionRequest missing required entries');
      logAnalyticsEvent({
        category: 'exception',
        event: 'conversion request',
        name: `Missing required entries: orderUID ${orderUID}, userUID ${userUID}`,
      });
      return null;
    }

    const fetchURL = await createAPIRequestURL(authRequestInfo, '/track/conversion');

    if (!fetchURL) {
      console.error('cannot create conversion URL');
      logAnalyticsEvent({
        category: 'exception',
        event: 'conversion request',
        name: 'Cannot create url',
      });
      return null;
    }

    try {
      const body: ConversionEventBody = {
        client: this.clientId,
        order: orderUID,
        items: items,
        user: userUID,
        experiments: this.clientExperiments,
      };

      const result = await fetchRequest({
        url: fetchURL.toString(),
        method: 'POST',
        body,
        iOSBundleIdentifier: this.iOSBundleIdentifier,
        authRequestInfo,
        keepalive: true,
      });

      if (result.status !== ResponseCode.success) {
        logAnalyticsEvent({
          category: 'exception',
          event: 'record-conversion',
          name: `${result.status}`,
          dimensions: { provider: this.clientId, description: await result.text() } as ExceptionDimensions,
        });
        return null;
      }

      const response: ConversionResponse = await result.json();
      return response;
    } catch (error) {
      console.error(error);
      logAnalyticsEvent({
        category: 'exception',
        event: 'rec-conv req',
        name: error.message,
      });
      return null;
    }
  }
}
